import { FormGridField } from "../../components/FormGrid";

export interface GameSelectorDefinition {
    name: string;
    id: string;
    label: string;
    selectedGames: (string | number)[];
    completeList: { label: any; value: string | number }[];
    schemaName: string;
    bundlesList: { label: any; value: string | number }[];
    exclusive?: boolean;
    disabled?: boolean;
    fieldOverrides?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildGameSelectorDefinition({
    name,
    id,
    label,
    selectedGames,
    completeList,
    schemaName,
    bundlesList,
    exclusive,
    fieldOverrides,
    disabled
}: {
    name: string;
    id: string;
    label: string;
    selectedGames: (string | number)[];
    completeList: { label: any; value: string | number }[];
    schemaName: string;
    bundlesList: { label: any; value: string | number; games: any[] }[];
    exclusive?: boolean;
    fieldOverrides?: any;
    disabled?: boolean;
}): GameSelectorDefinition {
    return {
        name,
        id,
        label,
        selectedGames,
        completeList,
        schemaName,
        bundlesList,
        exclusive,
        fieldOverrides,
        disabled,
        buildFormGridField: _createGameSelectorField
    };
}

function _createGameSelectorField(schema): FormGridField {
    const {
        name,
        id,
        label,
        selectedGames,
        completeList,
        schemaName,
        fieldOverrides,
        bundlesList,
        exclusive,
        disabled
    } = this;

    return {
        name,
        fieldType: "gameSelector",
        fieldOptions: {
            id,
            label,
            completeList,
            selectedGames,
            exclusive,
            disabled,
            bundlesList
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-12",
        formSpacing: true,
        ...fieldOverrides
    };
}
